import React from 'react';
import { cn } from '../utils/cn';
import { Background } from './Background';
import { Header } from './Header';

export const Layout = ({ children, className, onSettingsClick, showHeader = true }) => {
    return (
        <div className="relative h-[100dvh] w-full max-w-md mx-auto flex flex-col overflow-hidden font-sans text-text-primary">
            <Background />

            {showHeader && <Header onSettingsClick={onSettingsClick} />}

            <main className={cn(
                "flex-1 min-h-0 flex flex-col relative z-10 w-full overflow-hidden p-4 scrollbar-hide",
                className
            )}>
                {children}
            </main>
        </div>
    );
};
